// Whether a provider block holds any value: they fill these with empty strings, so presence alone is not data.

export function hasText(block: object | null | undefined): boolean {
  return !!block && Object.values(block).some((value) => typeof value === 'string' && value.trim());
}
